/* eslint-disable camelcase */
import { Component } from 'react';
import { AppState } from '../app/store/rootReducers';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import Config from '../config/config';
import { setProfileFromTnAccount } from '../app/store/auth/actions';
import Loader from '../views/components/loader/Loader';
import ApiUrls from '../constants/ApiUrls';
import LocalStorageKeys from '../constants/LocalStorageKeys';
import { getCookie } from "../utilites/cookies";
import { YETTEL_ACCOUNT_COOKIE } from "../constants/CookieConstants";

type Props = {
  from: string;
};

type NalogTokenResponse = {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  token_type: 'Bearer';
};

const isValidNalogTokenResponse = (obj: any) => {
  return (
    obj.hasOwnProperty('access_token') &&
    typeof obj.access_token === 'string' &&
    obj.hasOwnProperty('refresh_token') &&
    typeof obj.refresh_token === 'string' &&
    obj.hasOwnProperty('expires_in') &&
    typeof obj.expires_in === 'number' &&
    obj.hasOwnProperty('token_type') &&
    obj.token_type === 'Bearer'
  );
};

type ReceiveFromTnAccountContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Props;

export class ReceiveFromTnAccountContainer extends Component<ReceiveFromTnAccountContainerProps, {}> {

  from: string;

  constructor(props: ReceiveFromTnAccountContainerProps) {
    super(props);

    const searchParams = new URLSearchParams(window.location.search);
    const codeVerifier = localStorage.getItem(LocalStorageKeys.CODE_VERIFIER) || '';

    this.from = JSON.parse(searchParams.get('state') || '{}')?.from;

    if (codeVerifier) {
      this.fetchToken(codeVerifier);
    } else {
      window.location.replace(this.from);
    }
  }

  fetchToken = (codeVerifier: string) => {
    const searchParams = new URLSearchParams(window.location.search);

    fetch(`${Config.tnAccountDomain}/api/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        client_id: Config.tnAccountClientId,
        code: searchParams.get('code') || '',
        grant_type: 'authorization_code',
        redirect_uri: `${Config.domain}${Config.prefixUrl}/session-oauth/`,
        code_verifier: codeVerifier,
      }),
    })
      .then((response) => {
        const res = response.json();
        res.then((data: NalogTokenResponse) => {
          if (isValidNalogTokenResponse(data)) {
            this.handleSuccess(data);
          } else {
            this.handleError();
          }
        });
      })
      .catch((e) => {
        console.log(e);
        this.handleError();
      });
  };

  handleSuccess = async (accessToken: NalogTokenResponse) => {
    const cookieToken = getCookie(YETTEL_ACCOUNT_COOKIE) ?? '';
    fetch(`${Config.api.baseUrl}${ApiUrls.USER.LOGIN}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Account-Logged-In-User': cookieToken
      },
      body: JSON.stringify({
        accessToken: accessToken.access_token,
        refreshToken: accessToken.refresh_token,
        expires: accessToken.expires_in,
        tokenType: accessToken.token_type,
      }),
    })
      .then((_) => {
        localStorage.removeItem(LocalStorageKeys.LOGIN_STATUS);
        window.location.replace(this.from);
      })
      .catch((e) => {
        console.log(e);
        this.handleError();
      });
  };

  handleError = () => {
    if (this.from) {
      window.location.replace(this.from);
    } else {
      window.location.replace(`${Config.domain}${Config.prefixUrl}`);
    }
  };

  render() {
    return (
      <>
        <Loader loadingLabel="..." />
      </>
    );
  }

}

const mapStateToProps = (state: AppState) => {
  return {
    language: state.language,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      setProfileFromTnAccount,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReceiveFromTnAccountContainer);
